
import Vue from 'vue';
import throttle from 'lodash.throttle';
import { addClass } from '@/util/domClass.ts';
import getDiffY from '@/util/domGetDiffY';

Vue.directive('scrolltop', {
  inserted(el: any, binding: any) {
    el.$jfun = throttle(() => {
      binding.value(el);
    });

    window.addEventListener('scroll', el.$jfun);
  },
  unbind(el: any) {
    window.removeEventListener('scroll', el.$jfun);
  },
});

// y default 50, 表示元素向上滚动到其顶部距离视口底部上方50px
Vue.directive('scrollanim', {
  // 被绑定元素插入父节点时调用
  inserted(el, binding) {
    const y = Number(binding.arg) || 50;
    const diff = getDiffY(el);

    if (diff > y) {
      // 是否需要立即动画
      // setTimeout(() => {
      addClass(el, 'animated');
      // }, 1000);
    } else {
      const f = throttle((evt: any) => {
        if (binding.value(evt, el)) {
          window.removeEventListener('scroll', f);
        }
      }, 200);

      window.addEventListener('scroll', f);
    }
  },
});
